import useController from "@hooks/useController"

export default function useLoginController(): Auth.Controllers.Login {
    const controller = useController('/api/auth')

    const user = controller.get('user')
    const login = () => controller.post('login')
    const logout = () => controller.post('logout')
    const loginAsUser = (id: string | number) => controller.post(`login/${id}`)

    return { user, loginAsUser, login, logout }
}